import { Component, inject } from '@angular/core';

import { AuthService } from '../../../authentication/_services/auth.service';

@Component({
  selector: 'app-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  private authService = inject(AuthService);

  isSupport = false;

  constructor() {
    this.isSupport = this.authService.hasAnyRole(['ROLE_Application Support']);
  }
}
